export default {
      id: "comments-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons-sprite.ef97e87.svg#comments-usage",
      toString: function () {
        return this.url;
      }
    }